export function formatMoney(value) {
    const rounded = Math.round(value);
    return rounded.toLocaleString('ru-RU') + ' ₽';
}

export function formatNumber(value) {
    return Math.round(value).toLocaleString('ru-RU');
}

export function formatDateTime(timestamp) {
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

    if (isToday) return `сегодня, ${time}`;
    if (isYesterday) return `вчера, ${time}`;
    return `${date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })}, ${time}`;
}

export function formatDate(timestamp) {
    return new Date(timestamp).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function escapeHtml(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

export function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

export function startOfDay(timestamp) {
    const d = new Date(timestamp);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
}

export function daysAgo(n) {
    return Date.now() - n * 24 * 60 * 60 * 1000;
}
